var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"item-value":"id","item-text":"name","items":_vm.statusesList,"readonly":_vm.readonly,"rules":_vm.calculateRules,"flat":"","solo":"","dense":"","small-chips":"","hide-details":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var select = ref.select;
var selected = ref.selected;
var disabled = ref.disabled;
return [_c('v-chip',{attrs:{"text-color":"white","color":item.color,"input-value":selected,"disabled":disabled,"small":""},on:{"click":select}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])]}}])},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }